import React from 'react';
import styles from './formsBrowser.module.scss';
import { useTranslation } from 'react-i18next';
import { PanelRow } from '../../components/panel/PanelRow';
import { Panel } from '../../components/panel/Panel';
import { FormDetails } from './FormDetails';
import { RelatedForms } from './RelatedForms';
import { SearchResults } from './SearchResults';
import { Accordion } from '../../components/accordion/Accordion';
import { FavoritedForms } from './FavoritedForms';
import { RecentForms } from './RecentForms';
import { FormsHome } from './FormsHome';
import {
    FilterProps,
    LocalStorageProps,
    SearchProps,
    SelectionProps,
} from './types/FormTypes';

export const FormDisplayToggle = React.memo(
    React.forwardRef<
        HTMLDivElement,
        {
            selectionProps: SelectionProps;
            searchProps: SearchProps;
            filterProps: FilterProps;
            localStorageProps: LocalStorageProps;
        }
    >((props, ref) => {
        const { t } = useTranslation();

        try {
            const {
                selectionProps,
                selectionProps: { isFormSelected },
                searchProps: { isSearchSelected },
                searchProps,
                filterProps,
                localStorageProps,
            } = props;

            if (isFormSelected) {
                return (
                    <>
                        <div className={styles.panelContainer}>
                            <PanelRow>
                                <Panel>
                                    <FormDetails
                                        ref={ref}
                                        selectionProps={selectionProps}
                                        localStorageProps={localStorageProps}
                                    />
                                </Panel>
                            </PanelRow>
                        </div>
                        <div className={styles.panelContainer}>
                            <PanelRow>
                                <Panel>
                                    <RelatedForms
                                        selectionProps={selectionProps}
                                    />
                                </Panel>
                            </PanelRow>
                        </div>
                    </>
                );
            } else if (isSearchSelected) {
                return (
                    <div className={styles.panelContainer}>
                        <PanelRow>
                            <Panel>
                                <SearchResults
                                    selectionProps={selectionProps}
                                    searchProps={searchProps}
                                />
                            </Panel>
                        </PanelRow>
                    </div>
                );
            } else {
                return (
                    <>
                        <div className={styles.panelContainer}>
                            <PanelRow>
                                <Panel>
                                    <Accordion
                                        title={t('FormsBrowser.FavoritedTitle')}
                                        component={
                                            <FavoritedForms
                                                selectionProps={selectionProps}
                                                localStorageProps={
                                                    localStorageProps
                                                }
                                            />
                                        }
                                    />
                                </Panel>
                            </PanelRow>
                        </div>
                        <div className={styles.panelContainer}>
                            <PanelRow>
                                <Panel>
                                    <Accordion
                                        title={t(
                                            'FormsBrowser.RecentlyVisitedTitle',
                                        )}
                                        component={
                                            <RecentForms
                                                selectionProps={selectionProps}
                                                localStorageProps={
                                                    localStorageProps
                                                }
                                            />
                                        }
                                    />
                                </Panel>
                            </PanelRow>
                        </div>
                        <div className={styles.panelContainer}>
                            <PanelRow>
                                <Panel>
                                    <FormsHome
                                        selectionProps={selectionProps}
                                        filterProps={filterProps}
                                    />
                                </Panel>
                            </PanelRow>
                        </div>
                    </>
                );
            }
        } catch {
            return null;
        }
    }),
);
